import React from 'react';
import Feed from '../components/Feed/Feed';
import Head from '../components/Header/Head';
import Header from '../components/Header/Header';
import withApollo from '../lib/withApollo';

const CreatedFeed = () => {
  return (
    <>
      <Head title="New Travel Blogs" feedUrl="created" />
      <Header active="new" subheader="New" />
      <Feed active="new" minScore={0} orderby="createdAt" />
    </>
  );
};

export default withApollo(CreatedFeed);
